import {
  AdditionalVisitDto,
  HL7AckProcessing,
  HL7IncomingSettingsDto,
  HL7OutgoingSettingsDto,
  HL7SettingsDto,
  OverwriteTimeOption,
} from '@lmt/shared-types';
import { UseFormReturn } from 'react-hook-form';

export type HL7OutgoingSettingsData = Omit<
  HL7OutgoingSettingsDto,
  'enabled' | 'encoding' | 'outgoingMessageStorageFolder'
>;

export type HL7IncomingSettingsData = Omit<
  HL7IncomingSettingsDto,
  'enabled' | 'port' | 'sslPort' | 'visitLengthInSeconds' | 'additionalVisits'
> & {
  visitLengthInHours: number;
  additionalVisits: AdditionalVisitDto[];
};

export type HL7SettingsData = HL7SettingsDto &
  HL7OutgoingSettingsData &
  HL7IncomingSettingsData & {
    isHl7OutgoingEnabled: boolean;
  };

export interface HL7SettingsFormProps {
  form: UseFormReturn<HL7SettingsData>;
  isServerEnabled?: boolean;
  isCleanupJobGloballyEnabled?: boolean;
}

export const hl7DefaultSettings: HL7SettingsData = {
  onlyProcessMessagesForExistingPatients: false,
  subtenantId: 0,
  ackProcessing: HL7AckProcessing.Never,
  encoding: '',
  appName: '',
  facility: '',
  cleanupEnabled: false,
  deleteAfterMonths: 6,
  isCleanupJobEnabledGlobally: false,
  // Incoming settings
  incomingTransporterEnabled: false,
  defaultVisitTypeId: 0,
  visitStartTimeInSecondsSinceMidnight: 0,
  visitLengthInHours: 1,
  visitSearchBackwardDaysCount: 0,
  visitSearchForwardDaysCount: 2,
  caseSearchBackwardDaysCount: 2,
  caseSearchForwardDaysCount: 2,
  additionalVisits: [],
  overwriteTime: true,
  overwriteTimeOption: OverwriteTimeOption.OverwriteEndIfEmpty,
  // Outgoing settings
  outgoingTransporterEnabled: false,
  isHl7OutgoingEnabled: false,
  serverAddress: '',
  retryDelays: '',
  serverPort: 0,
  isSsl: false,
  filesDirectory: '',
};
